// extracted by mini-css-extract-plugin
export default {"medik8Section":"Medik8_medik8Section__qW3PT"};